import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

function HoursEntryEditDot({ hasEdits }) {
  const { t } = useTranslation();

  if (!hasEdits) {
    return null;
  }

  const label = t('personnelHoursHistory.hasEdits');

  return (
    <Tooltip title={label}>
      <Box
        component="span"
        role="img"
        aria-label={label}
        sx={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: 'warning.main',
          flexShrink: 0,
        }}
      />
    </Tooltip>
  );
}

export default HoursEntryEditDot;
